import Model from "../Model";

export interface TReportingPeriodApplicant {
  reportingPeriodApplicantId: number;
  reportingPeriodId: number;
  periodFrom: Date;
  periodTo: Date;
  reportingTypeCode: string;
  reportingTypeName: string;
  applicantId: number;
  firstName: string;
  lastName: string;
  partyId: number;
  partyPersonalIdentificationNumber: string;
  isEvaluationCandidate: string;
  evaluationReason: string;
  evaluationStatus: string;
  evaluationDate: Date;
  inputAvailableUntil: Date;
  expectedReportsNumber: number;
  submitedReportsNumber: number;
  publicationExists: boolean;
}

export interface IReportingPeriodApplicant extends TReportingPeriodApplicant {}

const ReportingPeriodApplicant = Model(
  (model: TReportingPeriodApplicant): IReportingPeriodApplicant => {
    const _reportingPeriodApplicant: TReportingPeriodApplicant = Object.assign(
      {},
      model
    );

    return {
      get reportingPeriodApplicantId() {
        return _reportingPeriodApplicant.reportingPeriodApplicantId;
      },
      set reportingPeriodApplicantId(value) {
        _reportingPeriodApplicant.reportingPeriodApplicantId = value;
      },
      get reportingPeriodId() {
        return _reportingPeriodApplicant.reportingPeriodId;
      },
      set reportingPeriodId(value) {
        _reportingPeriodApplicant.reportingPeriodId = value;
      },
      get periodFrom() {
        return _reportingPeriodApplicant.periodFrom;
      },
      set periodFrom(value) {
        _reportingPeriodApplicant.periodFrom = value;
      },
      get periodTo() {
        return _reportingPeriodApplicant.periodTo;
      },
      set periodTo(value) {
        _reportingPeriodApplicant.periodTo = value;
      },
      get reportingTypeCode() {
        return _reportingPeriodApplicant.reportingTypeCode;
      },
      set reportingTypeCode(value) {
        _reportingPeriodApplicant.reportingTypeCode = value;
      },
      get reportingTypeName() {
        return _reportingPeriodApplicant.reportingTypeName;
      },
      set reportingTypeName(value) {
        _reportingPeriodApplicant.reportingTypeName = value;
      },
      get applicantId() {
        return _reportingPeriodApplicant.applicantId;
      },
      set applicantId(value) {
        _reportingPeriodApplicant.applicantId = value;
      },
      get firstName() {
        return _reportingPeriodApplicant.firstName;
      },
      set firstName(value) {
        _reportingPeriodApplicant.firstName = value;
      },
      get lastName() {
        return _reportingPeriodApplicant.lastName;
      },
      set lastName(value) {
        _reportingPeriodApplicant.lastName = value;
      },
      get partyId() {
        return _reportingPeriodApplicant.partyId;
      },
      set partyId(value) {
        _reportingPeriodApplicant.partyId = value;
      },
      get partyPersonalIdentificationNumber() {
        return _reportingPeriodApplicant.partyPersonalIdentificationNumber;
      },
      set partyPersonalIdentificationNumber(value) {
        _reportingPeriodApplicant.partyPersonalIdentificationNumber = value;
      },
      get isEvaluationCandidate() {
        return _reportingPeriodApplicant.isEvaluationCandidate;
      },
      set isEvaluationCandidate(value) {
        _reportingPeriodApplicant.isEvaluationCandidate = value;
      },
      get evaluationReason() {
        return _reportingPeriodApplicant.evaluationReason;
      },
      set evaluationReason(value) {
        _reportingPeriodApplicant.evaluationReason = value;
      },
      get evaluationStatus() {
        return _reportingPeriodApplicant.evaluationStatus;
      },
      set evaluationStatus(value) {
        _reportingPeriodApplicant.evaluationStatus = value;
      },
      get evaluationDate() {
        return _reportingPeriodApplicant.evaluationDate;
      },
      set evaluationDate(value) {
        _reportingPeriodApplicant.evaluationDate = value;
      },
      get inputAvailableUntil() {
        return _reportingPeriodApplicant.inputAvailableUntil;
      },
      set inputAvailableUntil(value) {
        _reportingPeriodApplicant.inputAvailableUntil = value;
      },
      get expectedReportsNumber() {
        return _reportingPeriodApplicant.expectedReportsNumber;
      },
      set expectedReportsNumber(value) {
        _reportingPeriodApplicant.expectedReportsNumber = value;
      },
      get submitedReportsNumber() {
        return _reportingPeriodApplicant.submitedReportsNumber;
      },
      set submitedReportsNumber(value) {
        _reportingPeriodApplicant.submitedReportsNumber = value;
      },
      get publicationExists() {
        return _reportingPeriodApplicant.publicationExists;
      },
      set publicationExists(value) {
        _reportingPeriodApplicant.publicationExists = value;
      }
    };
  }
);

export default ReportingPeriodApplicant;
